import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPageView = (path, title) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title || document.title,
  });
};

export const trackEvent = (category, action, label, value) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event({ category, action, label, value });
};
